import { AccountServiceN } from './../../../accounts-v2/services/account.services';
import { Directive, Input, forwardRef } from '@angular/core';
import { AbstractControl, Validator, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { ValidatorBaseDirective } from './validator-base.directive';

@Directive({
    selector: '[asyncEmailValidator]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: LeadAccountEmailValidatorDirective, multi: true
        }
    ]
})
export class LeadAccountEmailValidatorDirective extends ValidatorBaseDirective implements Validator {

    @Input('accountId') accountId: number = 0;
    @Input('leadId') leadId: number = 0;
    @Input() asyncEmailValidator: string = "";

    constructor(private _accountService: AccountServiceN) {
        super('asyncEmailValidator');
    }

    validate(c: AbstractControl) {

        if(!c.value || this.asyncEmailValidator) return new Promise(resolve => resolve(null));

        return new Promise(resolve =>
            this._accountService.accountEmailValidation(c.value,this.accountId,this.leadId).subscribe(res => {
                if (res == true) {
                    resolve(null);
                }
                else {
                    resolve({ emailExists: { valid: false } });
                }
            }));
    }
}
